export default __webpack_public_path__ + "static/media/coveralls.bea47f4b.svg";